import Footer from './Footer';
import SubHeader from './SubHeader';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import ScenarioUtils from '../utils/scenarioUtils';
import './ScenarioPopup.scss';
import { useEffect, useState } from 'react';
import { setReadMessages } from '../store/gameSlice';
import RoleString from './RoleString';
import Notifier from './Notifier';

function ScenarioPopup(props: { onCancel: () => void }) {
    const dispatch = useDispatch();
    const { playerView, readMessages } = useSelector((state: RootState) => state.game);
    const [showNotifier, setShowNotifier] = useState(false);
    const { onCancel } = props;

    useEffect(() => {
        if (!readMessages) {
            setShowNotifier(true);
            dispatch(setReadMessages());

        }
    }, [])

    if (!playerView) {
        return <></>;
    }

    const messageLen = playerView?.messages?.length || 0;

    return <div className="mafia-container-wrapper">
        <div className="mafia-container">
            <SubHeader>
                Latest messages ({messageLen}){showNotifier && <Notifier />}
            </SubHeader>
            <div className='mafia-list-container mafia-scenario-description'>
                <div className='message-container'>

                    {messageLen > 0 && playerView.messages.map((m, index) => {
                        const indexer = playerView.messages?.length > 0 ? <span className='mafia'>{index + 1}) </span> : <></>;
                        return <div>
                            <div className='mafia-message-row mark'>{indexer}{m.text}</div>
                        </div>
                    })}
                </div>
                <SubHeader>
                    Current Scenario
                </SubHeader>
                <RoleString raw_scenario={playerView.scenario} />
                <hr />
                {playerView.scenario.map(role => {
                    const cl = ScenarioUtils.GetRoleClass(role);
                    return <div className={`${cl}`}>{role}</div>
                })}
            </div>
        </div>
        <Footer>
            <button onClick={onCancel}>Back</button>
        </Footer>
    </div>

}

export default ScenarioPopup;